import { useDispatch } from 'react-redux';
import { useHistory, withRouter, useLocation } from 'react-router-dom';
import React from 'react';
import logo from '../../images/aaseal.png';
import { loginUser } from '../../redux/actions/user';
import './index.css';
import { SignupPage } from '../SignupPage';
import { SignupAlert } from './components/SignupAlert';
import mobileLogo from '../../images/icon-mobile-app.png';
import { OneloginButton } from './components/OneLoginButton';
import Axios from 'axios';
import { CognitoButton } from './components/CognitoButton';

const LoginPageComponent = (props) => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const [backgroundImage, setBackgroundImage] = React.useState('');
  const [errorOnLogin, setErrorOnLogin] = React.useState(false);
  const [showSignup, setShowSignup] = React.useState(false);
  const [showRequestAlert, setShowRequestAlert] = React.useState(false);
  const [mobileAppVersion, setMobileAppVersion] = React.useState('3.9.X');
  React.useEffect(() => {
    // fetchBackgroundImage(); -- deprecated
    fetchMobileAppVersion();
  }, []);

  const handleRedirect = () => {
    if (location.state !== undefined) {
      if (location.state.from !== undefined) {
        history.push(location.state.from.pathname);
      } else {
        history.push('/');
      }
    } else {
      history.push('/');
    }
  }

  const fetchMobileAppVersion = async () => {
    await Axios.post('https://itunes.apple.com/lookup?bundleId=org.aacounty.inventoryscanner')
      .then((res) => {
        setMobileAppVersion(res.data.results[0].version);
      })
      .catch((err) => {
console.log('Error: /frontend/src/pages/LoginPage/index', err);
      });
  };

  const handleLogin = async (json) => {
    const response = await fetch(window._env_.REACT_APP_AUTH_ENDPOINT, {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        access_token: json.accessToken,
        version: '3.2.0',
      }),
      credentials: 'include',
    });

    if (response.ok) {
      const data = await response.json();

      if (data.accessToken) {
        console.log('Login Page Data: ' + JSON.stringify(data));
        dispatch(loginUser(data));
        handleRedirect();
      } else {
        console.log(data);
      }
    } else {
      setErrorOnLogin(true);
      console.log(response);
    }
  };

  const errorMessage = () => {
    if (errorOnLogin) {
      return (
        <div className='alert alert-danger' role='alert'>
          <p>An error occurred while trying to login.</p>
        </div>
      );
    }
  };
  const LoginBody = () => {
    return (
      <div
        style={{
          backgroundColor: 'rgb(255, 255, 255, 0.8)',
          borderRadius: '12px',
          // boxShadow: '0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22)',
          position: 'relative',
          overflow: 'hidden',
          width: '400px',
          maxWidth: '1000px',
          minHeight: '500px',
          // 450 when google button removed
        }}>
        <div className='form-container sign-in-container'>
          <div
            style={{
              backgroundColor: 'rgb(255, 255, 255, 0.5)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
              // padding: '0 50px',
              height: '100%',
              textAlign: 'center',
            }}>
            <h3 className='font-weight-bold text-dark m-2'>Asset Inventory</h3>
            <h6>Version {process.env.REACT_APP_VERSION}</h6>
            <div className='social-container'>
              <img src={logo} alt='Logo' style={{ width: '50%' }} />
            </div>
            <p></p>
            {/* <GoogleLoginButton handleLogin={handleLogin} onSuccess={handleLogin} onFailure={handleLoginFailure} /> */}
            <OneloginButton title='Sign in with OneLogin' variant='danger' />
            <OneloginButton title='OIT Request Form Sign In' variant='info' />
            {/* <CognitoButton title='Sign in with Cognito (beta)' variant='primary'/> */}
            {/* <RequestLoginButton handleLogin={handleLogin} onSuccess={handleLogin} onFailure={handleLoginFailure} /> */}

            <a href='#click/link/to/request/access' style={{ color: '#666' }} className='m-2' onClick={() => setShowSignup(true)}>
              Are you a property coordinator and need to manage inventory? Request Access here.
            </a>
            <SignupPage isVisible={showSignup} setIsVisible={setShowSignup} setShowRequestAlert={setShowRequestAlert} />
          </div>
        </div>
      </div>
    );
  };

  const MobileAppVersionBody = () => {
    return (
      <div
        style={{
          backgroundColor: 'rgb(255, 255, 255, 0.8)',
          borderRadius: '12px',
          // boxShadow: '0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22)',
          position: 'relative',
          overflow: 'hidden',
          width: '400px',
          maxWidth: '1000px',
          padding: 5,
        }}>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <div style={{ justifyContent: 'center', alignItems: 'center', width: '25%' }}>
            <img src={mobileLogo} alt='Logo' style={{ width: '80%', borderRadius: 10 }} />
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
            }}>
            <h5>
              <strong>Compatible Mobile App Version</strong>
            </h5>
            <h6>iOS: {mobileAppVersion}</h6>
            <h6>Android: {mobileAppVersion}</h6>
          </div>
        </div>
      </div>
    );
  };

  var outerContainerStyles = {
    backgroundImage: `url(${backgroundImage})`,
    height: '100%',
    width: '100%',
    position: 'fixed',
    display: 'block',
    backgroundRepeat: 'repeat-x',
    backgroundSize: 'cover',
    WebkitFilter: 'blur(5px) opacity(50%)',
    WebkitTransition: 'background-image 2s ease',
    transition: 'background-image 2s ease',
  };

  
  return (
        <div>
      <div style={outerContainerStyles}></div>
      {showRequestAlert ? <SignupAlert visible={showRequestAlert} setVisible={setShowRequestAlert} /> : null}
      <div
        style={{
          backgroundColor: '#3A3F44',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          fontFamily: 'Montserrat',
          height: '100vh',
        }}>
        {LoginBody()}
        <div className='p-2'>{errorMessage()}</div>
        {MobileAppVersionBody()}
      </div>
    </div>
  );
};

export const LoginPage = withRouter(LoginPageComponent);
